import { useQuery } from '@tanstack/react-query';
import { useTranslation } from '../../i18n';
import styles from './CatalogCTA.module.css';

interface Props {
  slug: string;
}

export function CatalogCTA({ slug }: Props) {
  const { t } = useTranslation();
  const { data: stats } = useQuery<{ collectors: number; items: number }>({
    queryKey: ['community-stats'],
    queryFn: () => fetch('/api/community/stats').then((r) => r.json()),
    staleTime: 5 * 60 * 1000,
  });

  const loginUrl = `/login?ref=catalog&from=${encodeURIComponent(slug)}`;

  return (
    <div className={styles.cta}>
      <span className={styles.headline}>{t('share.ctaHeadline')}</span>
      {stats && stats.collectors > 0 && (
        <span className={styles.subtext}>
          {t('share.ctaSocialProof')
            .replace('{collectors}', String(stats.collectors))
            .replace('{items}', String(stats.items))}
        </span>
      )}
      <a href={loginUrl} className={styles.signupBtn}>
        {t('share.ctaButton')}
      </a>
    </div>
  );
}
